export default __webpack_public_path__ + "static/media/Websites-SEB.9784a79f.png";